import styled from 'styled-components';
import { ButtonBoldM } from '../../styles/globals';
import { ITheme } from '../../styles/theme';

interface IPaginationBox {
  theme: ITheme;
  active?: boolean;
  disabled?: boolean;
}

export const PaginationCont = styled.div<IPaginationBox>`
  display: flex;
  flex-direction: row;
  height: 40px;
  align-items: center;

  .ant-pagination {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .ant-pagination-item {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    border: none;

    ${({ theme, active }: IPaginationBox) => `
      cursor: pointer;
      color: ${theme.colors.primary[100]};
      margin: 0 ${theme.layout.spacing.nano} 0 0;
      background: ${active ? theme.colors.neutral.primary[10] : theme.colors.neutral.primary[0]};
    `}

    &.ant-pagination-item-active {
      ${({ theme }: IPaginationBox) => `
        background: ${theme.colors.neutral.primary[10]};
        border: none;
        color: ${theme.colors.neutral.primary[100]};

        &.ant-pagination-item-active a {
          font-weight: 400;
          font-size: 16px;
          line-height: 16px;
          color: ${theme.colors.neutral.primary[100]};
        }
     `}
    }
  }
  .ant-pagination-jump-next {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    border: none;
    ${({ theme, active }: IPaginationBox) => `
      cursor: pointer;
      color: ${theme.colors.neutral.primary[100]};
      margin: 0 ${theme.layout.spacing.nano} 0 0;
      background: ${active ? theme.colors.neutral.primary[10] : theme.colors.neutral.primary[0]};
     `}
  }
  .ant-pagination-item-container {
    width: 24px;
    justify-content: center;
    position: relative;

    span {
      &.ant-pagination-item-ellipsis {
        display: flex;
        top: 4px;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        ${({ theme }: IPaginationBox) => `
        color: ${theme.colors.neutral.primary[100]};
        `}
      }
      &.anticon {
        svg {
          ${({ theme }: IPaginationBox) => `
            fill: ${theme.colors.neutral.primary[100]};
        `}
        }
      }
    }
  }
`;

export const PagiItemBox = styled(ButtonBoldM)<IPaginationBox>`
  font-size: 13px;
  width: 34px;
  height: 30px;
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  font-weight: 500;
  padding-top: 2px;

  ${({ theme, active, disabled }: IPaginationBox) => `
    margin: 0 ${theme.layout.spacing.nano} 0 0;
    background: ${active ? theme.colors.primary[10] : theme.colors.neutral.primary[0]};
    border: ${active ? `2px solid ${theme.colors.primary[70]}` : 'none'};
    color: ${theme.colors.neutral.primary[100]};
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
      ${
  disabled
    ? `
      background: ${theme.colors.neutral.primary[10]};
      color: ${theme.colors.neutral.primary[50]};
      opacity: 0.7;
     `
    : ''
};
     ${
  !disabled
    ? `
        &:hover {
        background: ${theme.colors.primary[10]};
      }
      &::selection {
        color: ${theme.colors.neutral.primary[100]};
        background: none;
}
     `
    : ''
};
     `}
`;
